import React from "react";
import Pill from "../../ui/atoms/Pill";

export type EnrolledThroughType =
  | "online"
  | "excel"
  | "offline"
  | "partner_app_offline"
  | (string & {});

interface EnrolledThroughPillProps {
  enrolledThrough: EnrolledThroughType;
}

const EnrolledThroughPill: React.FC<EnrolledThroughPillProps> = ({ enrolledThrough }) => {
  const classMap: Partial<Record<EnrolledThroughType, string>> = {
    online: "enrolled-through-pill online",
    excel: "enrolled-through-pill excel",
    offline: "enrolled-through-pill offline",
    partner_app_offline: "enrolled-through-pill offline",
  };

  const labelMap: Partial<Record<EnrolledThroughType, string>> = {
    online: "Online",
    excel: "Excel",
    offline: "Offline",
    partner_app_offline: "Partner App - Offline",
  };

  return (
    <Pill className={classMap[enrolledThrough] ?? "enrolled-through-pill offline"}>
      {labelMap[enrolledThrough] ?? enrolledThrough}
    </Pill>
  );
};

export default EnrolledThroughPill;
